// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 20px 10px;
  height: 100%;
  width: 100%;
}
.wrapper .title {
  font-size: 18px;
  font-family: Tusker, sans-serif;
  color: white;
  text-align: center;
  padding: 20px 0px;
}
.wrapper ion-col .card-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: white;
  border-radius: 10px;
  height: 100%;
  padding: 10px;
}
.wrapper ion-col .card-item .image-block {
  width: 100%;
  height: 120px;
  position: relative;
}
.wrapper ion-col .card-item .image-block ion-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 10px;
}
.wrapper ion-col .card-item .image-block ion-icon {
  position: absolute;
  top: 20%;
  right: 20%;
}
.wrapper ion-col .card-item .info-block {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.wrapper ion-col .card-item .info-block h3 {
  width: 70%;
  font-size: 15px;
  font-family: Tusker, sans-serif;
  margin-right: 10px;
}
.wrapper ion-col .card-item .info-block span {
  width: 30%;
}

.content_block {
  margin-bottom: 70px;
  height: 55vh;
  overflow-y: auto;
}

.footer-btn {
  position: fixed;
  bottom: 20px;
  left: 0px;
  right: 0px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.footer-btn ion-button {
  width: 90%;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: #9f9f9f;
  text-align: left;
  padding-top: 6px;
}

.deposit_text {
  padding-top: 10px;
  font-size: 14px;
  font-family: Tusker, sans-serif;
  color: #878787;
}`, "",{"version":3,"sources":["webpack://./src/app/components/recomendation-article-modal/recomendation-article-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AACJ;AAAI;EACI,eAAA;EACA,+BAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAER;AAIQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAFZ;AAGY;EACI,WAAA;EACA,aAAA;EACA,kBAAA;AADhB;AAEgB;EACI,YAAA;EACA,aAAA;EAEA,mBAAA;EACA,mBAAA;AADpB;AAGgB;EACI,kBAAA;EACA,QAAA;EACA,UAAA;AADpB;AAKY;EACI,aAAA;EACA,uBAAA;EACA,8BAAA;AAHhB;AAIgB;EACI,UAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;AAFpB;AAIgB;EACI,UAAA;AAFpB;;AAQA;EACI,mBAAA;EACA,YAAA;EACA,gBAAA;AALJ;;AAOA;EACI,eAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAJJ;AAKI;EACI,UAAA;AAHR;;AAMA;EACI,gCAAA;EACA,eAAA;EACA,cAAA;EACE,gBAAA;EACA,gBAAA;AAHN;;AAKE;EACE,iBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;AAFJ","sourcesContent":[".wrapper {\n    padding: 20px 10px;\n    height: 100%;\n    width: 100%;\n    .title {\n        font-size: 18px;\n        font-family: Tusker, sans-serif;\n        color: white;\n        text-align: center;\n        padding: 20px 0px;\n    }\n    ion-col {\n\n      \n   \n        .card-item {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-direction: column;\n            background: white;\n            border-radius: 10px;\n            height: 100%;\n            padding: 10px;\n            .image-block {\n                width: 100%;\n                height: 120px;\n                position: relative;\n                ion-img {\n                    width: 120px;\n                    height: 120px;\n\n                    object-fit: contain;\n                    margin-bottom: 10px;\n                }\n                ion-icon {\n                    position: absolute;\n                    top: 20%;\n                    right: 20%\n                }\n            }\n         \n            .info-block {\n                display: flex;\n                align-items:flex-start;\n                justify-content: space-between;\n                h3 {\n                    width: 70%;\n                    font-size: 15px;\n                    font-family: Tusker, sans-serif;\n                    margin-right: 10px;\n                }\n                span {\n                    width: 30%;\n                }\n            }\n        }\n    }\n}\n.content_block {\n    margin-bottom: 70px;\n    height: 55vh;\n    overflow-y: auto;\n}\n.footer-btn {\n    position: fixed;\n    bottom: 20px;\n    left: 0px;\n    right: 0px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    ion-button {\n        width: 90%;\n    }\n}\n.measurment_text {\n    font-family: AppFont, sans-serif;\n    font-size: 10px;\n    color: #9f9f9f;\n      text-align: left;\n      padding-top: 6px;\n  }\n  .deposit_text {\n    padding-top: 10px;\n    font-size: 14px;\n    font-family: Tusker, sans-serif;\n    color: #878787;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
